/* MixLight – interacțiuni pentru layout-ul ml (funcționează și în editorul de temă) */
(function () {
  var TEAL = '#0E7C86', INK = '#1C2326', LINE = '#D5DDDE';
  var timers = [];

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function once(el, key) { if (el['__ml' + key]) return false; el['__ml' + key] = true; return true; }

  // Butoane tip „pastilă” (filtre proiecte/software, pas pixel)
  function setPill(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var flat = btn.style.borderTopWidth === '0px' || btn.style.border === '0px' || btn.style.borderStyle === 'none';
    if (flat) {
      btn.style.background = on ? TEAL : '#F7F9F9';
      btn.style.color = on ? '#ffffff' : INK;
    } else {
      btn.style.borderColor = on ? TEAL : LINE;
      btn.style.background = on ? TEAL : '#ffffff';
      btn.style.color = on ? '#ffffff' : INK;
    }
  }

  function init(root) {
    // Tab-uri (homepage, produs)
    each(root, '[data-ml-tabs]', function (box) {
      if (!once(box, 'tabs')) return;
      var tabs = box.querySelectorAll('[data-ml-tab]');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.style.borderBottomColor = on ? INK : 'transparent';
          });
          each(box, '[data-ml-panel]', function (p) {
            p.hidden = p.getAttribute('data-ml-panel') !== tab.getAttribute('data-ml-tab');
          });
        });
      });
    });

    // Filtre (proiecte, software)
    each(root, '[data-ml-filter]', function (group) {
      if (!once(group, 'filter')) return;
      var name = group.getAttribute('data-ml-filter');
      var items = document.querySelector('[data-ml-items="' + name + '"]');
      var btns = group.querySelectorAll('[data-ml-opt]');
      Array.prototype.forEach.call(btns, function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(btns, function (x) { setPill(x, x === b); });
          var key = b.getAttribute('data-ml-opt');
          if (items) each(items, '[data-ml-key]', function (el) {
            el.hidden = key !== 'all' && el.getAttribute('data-ml-key') !== key;
          });
        });
      });
    });

    // Pas pixel pe pagina de produs
    each(root, '[data-ml-pitch]', function (box) {
      if (!once(box, 'pitch')) return;
      var btns = box.querySelectorAll('[data-ml-opt]');
      Array.prototype.forEach.call(btns, function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(btns, function (x) { setPill(x, x === b); });
          var p = b.getAttribute('data-ml-opt');
          each(document, '[data-ml-pitch-label]', function (l) { l.textContent = p; });
          var d = box.querySelector('[data-ml-pitch-dist]');
          if (d) d.textContent = b.getAttribute('data-dist') || '';
          each(document, '[data-ml-quote]', function (a) {
            a.setAttribute('href', a.getAttribute('data-base') + encodeURIComponent(' – ' + p));
          });
        });
      });
    });

    // FAQ
    each(root, '[data-ml-faq]', function (btn) {
      if (!once(btn, 'faq')) return;
      btn.addEventListener('click', function () {
        var ans = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (ans) ans.hidden = open;
        var s = btn.querySelector('[data-ml-sign]');
        if (s) s.textContent = open ? '+' : '−';
      });
    });

    // Galerie produs
    each(root, '[data-ml-gallery]', function (g) {
      if (!once(g, 'gallery')) return;
      var main = g.querySelector('[data-ml-main]');
      var zoom = g.querySelector('[data-ml-zoom]');
      var thumbs = g.querySelectorAll('[data-ml-thumb]');
      Array.prototype.forEach.call(thumbs, function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-ml-thumb');
          main.removeAttribute('srcset');
          if (zoom) zoom.href = t.getAttribute('data-ml-thumb').replace('width=1400', 'width=2400');
          Array.prototype.forEach.call(thumbs, function (x) { x.style.border = x === t ? '2px solid ' + INK : '1px solid #E4EAEB'; });
        });
      });
    });

    // Video proiecte
    each(root, '[data-ml-video]', function (btn) {
      if (!once(btn, 'video')) return;
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-ml-video');
        if (!src) return;
        var v = document.createElement('video');
        v.src = src;
        v.controls = true; v.autoplay = true; v.playsInline = true;
        v.setAttribute('style', 'width: 100%; height: 220px; object-fit: cover; display: block; background: #000');
        btn.replaceWith(v);
        var p = v.play && v.play();
        if (p && p.catch) p.catch(function () {});
      });
    });

    // Sortare și filtre colecție
    each(root, '[data-ml-sort]', function (sort) {
      if (!once(sort, 'sort')) return;
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
    each(root, '[data-ml-filters] input[type="checkbox"]', function (c) {
      if (!once(c, 'fcheck')) return;
      c.addEventListener('change', function () { c.form.submit(); });
    });

    // Grilă / listă
    each(root, '[data-ml-view]', function (b) {
      if (!once(b, 'view')) return;
      b.addEventListener('click', function () {
        var grid = document.querySelector('[data-ml-grid]');
        if (!grid) return;
        var list = b.getAttribute('data-ml-view') === 'list';
        grid.classList.toggle('is-list', list);
        each(document, '[data-ml-view]', function (x) {
          var on = x === b;
          x.style.borderColor = on ? INK : LINE;
          x.style.background = on ? '#F2F6F6' : '#ffffff';
        });
      });
    });

    // Slider (banner, testimoniale)
    each(root, '[data-ml-slider]', function (sl) {
      if (!once(sl, 'slider')) return;
      var slides = Array.prototype.filter.call(sl.children, function (c) { return c.hasAttribute('data-ml-slide'); });
      var dots = sl.querySelectorAll('[data-ml-dot]');
      var on = sl.getAttribute('data-dot-on') || TEAL, off = sl.getAttribute('data-dot-off') || '#C9D3D4';
      var cur = 0, timer = null;
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== cur; });
        Array.prototype.forEach.call(dots, function (d, k) { d.style.background = k === cur ? on : off; d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (sl.getAttribute('data-autoplay') !== 'true' || slides.length < 2 || window.Shopify && Shopify.designMode) return;
        var ms = (parseInt(sl.getAttribute('data-speed'), 10) || 6) * 1000;
        timer = setInterval(function () { show(cur + 1); }, ms);
        timers.push(timer);
      }
      Array.prototype.forEach.call(dots, function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
      sl.addEventListener('mouseenter', stop);
      sl.addEventListener('mouseleave', start);
      sl.__mlShow = function (el) { var k = slides.indexOf(el); if (k > -1) { stop(); show(k); } };
      start();
    });

    // Meniuri derulante (header)
    each(root, '[data-ml-dd]', function (dd) {
      if (!once(dd, 'dd')) return;
      var t = dd.querySelector('[data-ml-dd-toggle]');
      if (!t || !dd.querySelector('.ml-dd-panel')) return;
      t.addEventListener('click', function (e) {
        var touch = window.matchMedia('(hover: none)').matches;
        if (!dd.classList.contains('is-open') && (touch || dd.hasAttribute('data-ml-dd-click'))) {
          e.preventDefault();
          closeAll(dd);
          dd.classList.add('is-open');
          t.setAttribute('aria-expanded', 'true');
        }
      });
      dd.addEventListener('mouseenter', function () { t.setAttribute('aria-expanded', 'true'); });
      dd.addEventListener('mouseleave', function () { dd.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); });
    });

    // Meniu mobil
    each(root, '[data-ml-drawer-open]', function (b) {
      if (!once(b, 'drawer')) return;
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('aria-controls'));
        if (!d) return;
        d.hidden = false;
        document.body.classList.add('ml-drawer-open');
        b.setAttribute('aria-expanded', 'true');
        var x = d.querySelector('.ml-drawer-x'); if (x) x.focus();
      });
    });
    each(root, '[data-ml-drawer-close]', function (b) {
      if (!once(b, 'drawerx')) return;
      b.addEventListener('click', closeDrawer);
    });
  }

  function closeAll(except) {
    each(document, '[data-ml-dd].is-open', function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var t = d.querySelector('[data-ml-dd-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  function closeDrawer() {
    each(document, '[data-ml-drawer]', function (d) { d.hidden = true; });
    document.body.classList.remove('ml-drawer-open');
    each(document, '[data-ml-drawer-open]', function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-ml-dd]')) closeAll(null); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); closeDrawer(); } });

  init(document);

  // Precompletare mesaj din ?produs=
  var produs = new URLSearchParams(window.location.search).get('produs');
  if (produs) each(document, '[data-ml-prefill]', function (t) {
    if (!t.value) t.value = 'Doresc o ofertă pentru: ' + produs;
  });

  // Editorul de temă Shopify: reinițializare la modificări și afișarea blocului selectat
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var sl = el.closest && el.closest('[data-ml-slider]');
    if (sl && sl.__mlShow) sl.__mlShow(el);
    if (el.hasAttribute && el.hasAttribute('data-ml-tab')) el.click();
    var ans = el.querySelector && el.querySelector('[data-ml-faq][aria-expanded="false"]');
    if (ans) ans.click();
  });
})();
